package com.islamicmedia.shared.data.cache

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class MediaContentRow(
    val id: String? = null,
    @SerialName("cache_key") val cacheKey: String,
    val title: String,
    @SerialName("media_type") val mediaType: String,
    @SerialName("summarized_content") val summarizedContent: String,
    @SerialName("raw_search_count") val rawSearchCount: Int,
    @SerialName("content_length") val contentLength: Int,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("updated_at") val updatedAt: String? = null,
    @SerialName("expires_at") val expiresAt: String? = null,
    @SerialName("hit_count") val hitCount: Int = 0
)

@Serializable
data class MediaAnalysisRow(
    val id: String? = null,
    @SerialName("content_id") val contentId: String,
    @SerialName("criteria_hash") val criteriaHash: String,
    @SerialName("criteria_json") val criteriaJson: String,
    @SerialName("result_json") val resultJson: String,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("hit_count") val hitCount: Int = 0
)

@Serializable
data class AnalyticsEvent(
    val id: Long? = null,
    @SerialName("event_type") val eventType: String,
    val title: String? = null,
    @SerialName("media_type") val mediaType: String? = null,
    @SerialName("user_id") val userId: String? = null,
    @SerialName("user_email") val userEmail: String? = null,
    val score: Int? = null,
    @SerialName("islamic_score") val islamicScore: Int? = null,
    @SerialName("concern_categories") val concernCategories: List<String>? = null,
    @SerialName("criteria_hash") val criteriaHash: String? = null,
    @SerialName("criteria_json") val criteriaJson: String? = null,
    @SerialName("result_json") val resultJson: String? = null,
    @SerialName("cache_layer") val cacheLayer: String? = null,
    @SerialName("cost_usd") val costUsd: Double? = null,
    @SerialName("cost_breakdown_json") val costBreakdownJson: String? = null,
    @SerialName("duration_seconds") val durationSeconds: Int? = null,
    @SerialName("created_at") val createdAt: String? = null,
    /** How the title was searched; "kids_…" (kids_search, kids_photo) = a KIDZONE check run on this account. */
    @SerialName("search_source") val searchSource: String? = null
)
